module.exports = __webpack_public_path__ + "static/media/avatar3.9fda3819.png";